export default __webpack_public_path__ + "static/media/chat-icon-white.44bdbf82.svg";